'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {QuickStatusButton} from '../../../components/buttons/QuickStatusButton';
import {FilterInput} from '../../../components/lists/FilterInput';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {RequirementListView} from '../../../requirements/components/RequirementList/RequirementListView';
import {isTaskType, TaskType} from '../../enums/TaskType';
import {TaskNavigationBar} from '../TaskNavigationBar';
import {TaskViewBanner} from '../TaskViewBanner';


export function BaseTaskViewRequirementsView(props) {
  const isTemplate = props.taskType === TaskType.TEMPLATE;
  const task = props.task;

  return (
    <ProjectLayout
      className={classNames("TaskViewRequirements", props.className)}
      title={isTemplate ? props.templateTitle : props.viewTitle}
      showBackButton={true}
      onGoBack={props.onGoBack}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={(
        <FilterInput
          showFilterOptions={!isTemplate}
          searchOnly={isTemplate}
          filterModalOptions={props.filterModalOptions}

          onChangeDebounce={450}
          onFilterChange={props.onFilterChange}
          onFilterOptionsUpdate={props.onFilterOptionsUpdate}
          onSortOptionsUpdate={props.onSortOptionsUpdate}
        />
      )}
      headerRightContent={(
        <Fragment>
          <QuickStatusButton
            className="TaskViewRequirements__quickButton"
            model={task}
            status={get(task, 'status')}
            validStatuses={get(task, 'validStatuses')}
          />
          <Button
            className="TaskViewRequirements__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={(
        <TaskNavigationBar
          taskType={props.taskType}
          target={task}
        />
      )}
      bannerContent={(
        <TaskViewBanner
          userId={props.userId}
          taskType={props.taskType}
          task={task}
          quickMode={props.quickMode}
          parentName={props.parentName}
          minimalView={props.isMinimalView}

          showScheduled={props.showScheduled}
          showAssignment={props.showAssignment}
          showSubmitted={props.showSubmitted}
          showApproved={props.showApproved}
          showCancelled={props.showCancelled}
          showCameraButton={props.showCameraButton}
          showVideoButton={props.showVideoButton}
          showUploadButton={props.showUploadButton}
          showIOSUpButton={props.showIOSUpButton}
          enableFileUpload={props.enableFileUpload}
          showQuickSubmit={props.showQuickSubmit}
          showQuickApprove={props.showQuickApprove}
          canAddReq={props.canAddReq}
          supportsDownload={props.supportsDownload}
          canDownloadFiles={props.canDownloadFiles}

          onClickEdit={props.onClickEdit}
          onSelectSubmit={props.onSelectSubmit}
          onSelectApprove={props.onSelectApprove}
          onToggleMinimalView={props.onToggleMinimalView}
          onAddFileRequirement={props.onAddFileRequirement}
          onAddFormRequirement={props.onAddFormRequirement}
          onDownloadAllFiles={props.onDownloadAllFiles}

          init={props.init}
        />
      )}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <RequirementListView
        transitionGroupClass="ProjectLayout__content__container"
        itemClassName="ProjectLayout__content__item"
        list={props.list}
        useScroll={false}
        minimalView={props.isMinimalView}
        mode={props.mode}
        userId={props.userId}
        taskType={props.taskType}
        parentId={props.parentId}
        collection={props.collection}

        onClickItem={props.onClickItem}
        onItemContextMenu={props.onItemContextMenu}
        showCameraButton={props.showCameraButton}
        isCameraButtonEnabled={props.isCameraButtonEnabled}
        onCameraButtonClick={props.onCameraButtonClick}
        showVideoButton={props.showVideoButton}
        isVideoButtonEnabled={props.isVideoButtonEnabled}
        onVideoButtonClick={props.onVideoButtonClick}
        showUploadButton={props.showUploadButton}
        isUploadButtonEnabled={props.isUploadButtonEnabled}
        onUploadButtonClick={props.onUploadButtonClick}
        showIOSUpButton={props.showIOSUpButton}
        isUpIOSButtonEnabled={props.isUpIOSButtonEnabled}
        onUpIOSButtonClick={props.onUpIOSButtonClick}
        isFileSelectEnabled={props.isFileSelectEnabled}
        onFileSelect={props.onFileSelect}

        init={props.init}
      />
    </ProjectLayout>
  );
}

BaseTaskViewRequirementsView.propTypes = {
  className: T.string,
  showQuickSubmit: T.bool,
  showQuickApprove: T.bool,
  quickMode: isButtonState,
  isMinimalView: T.bool,
  userId: T.string.isRequired,
  taskType: isTaskType.isRequired,
  task: T.object,

  onClickOptions: T.func.isRequired,
  onClickEdit: T.func.isRequired,
  onToggleMinimalView: T.func.isRequired,
  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,

  viewTitle: T.string,
  templateTitle: T.string,

  init: T.bool,
};

BaseTaskViewRequirementsView.defaultProps = {
  init: true,
};

export const TaskViewRequirementsView = I18nComponent(BaseTaskViewRequirementsView, [
  {code: 'tasks.views.requirements.title', prop: 'viewTitle'},
  {code: 'tasks.views.requirements.template.title', prop: 'templateTitle'},
]);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewRequirements/TaskViewRequirementsView.js